

















import { Prop, Component, Vue } from "vue-property-decorator";
import ProjectManagerTableItem from "@/viewmodels/project-manager-table-item";

@Component({
  props: {
    selectable: Boolean,
    removable: Boolean
  }
})
export default class ProjectManagerTable extends Vue {
  @Prop({ default: () => [] }) selectedIds!: number[];
  @Prop({ default: () => [] }) items!: ProjectManagerTableItem[];

  get fields() {
    let fields = [
      { key: "name", label: "名前" },
      { key: "tel", label: "電話番号" },
      { key: "email", label: "メール" },
      { key: "type", label: "職種" },
      { key: "belongsTo", label: "支店" },
      { key: "actions", label: "" }
    ];
    if (this.$props.selectable) {
      fields.unshift({ key: "id", label: "" });
    }
    return fields;
  }

  get currentSelectedIds(): number[] {
    return this.selectedIds;
  }

  set currentSelectedIds(selectedIds: number[]) {
    this.$emit("select", selectedIds);
  }

  remove(id: number) {
    this.$emit("remove", id);
  }

  // custom class for tbody tr
  setTbodyTrClass(item: any) {
    const classes = [];
    if (item.isHiddenInfo === 1) classes.push("table-secondary");
    return classes;
  }
}
